import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import InventoryEditor from './InventoryEditor';
import LoadingDots from '../../shared/LoadingDots';
import { fetchInventories, saveInventory } from '../../../ReduxSlices/Inventories/inventorySlice';

const InventoryFormPage = ({ navigateTo, editingItem }) => {
  const dispatch = useDispatch();
  const { inventories, loading, submitting } = useSelector((state) => state.inventories);
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem('currentUser'));
    setCurrentUser(storedUser);
  }, []);

  useEffect(() => {
    if (inventories.length === 0) {
      dispatch(fetchInventories());
    }
  }, [dispatch, inventories.length]);

  const handleSubmit = async (form) => {
    try {
      await dispatch(
        saveInventory({
          inventory: form,
          id: editingItem?.id,
        })
      ).unwrap();
      navigateTo('inventory_list');
    } catch (err) {
      console.error('Failed to save inventory:', err);
      alert('Failed to save inventory. Please try again.');
    }
  };

  if (loading) return <LoadingDots />;

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <InventoryEditor
        onSubmit={handleSubmit}
        onCancel={() => navigateTo('inventory_list')}
        submitting={submitting}
        isEditing={!!editingItem}
        initialData={editingItem || null}
        currentUser={currentUser}
        inventories={inventories}
      />
    </div>
  );
};

export default InventoryFormPage;
